import {ButtonLink} from "@irati/ui/src/Link"
import styled, {css} from "styled-components"

export const CategoryCircle = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  ${({color}) => css`
    background-color: ${color};
  `}
`
export const CTA = styled(ButtonLink)`
  box-shadow: none;
  text-decoration: underline;
`
